import { h, Component } from 'preact';
import * as BaseComp from 'components/bolt/showtimes/showtimes2.js';
import { accessNested, joinClasses } from 'utils/utils';
import { getShowtimesData } from 'utils/bolt';

import Button from 'components/bolt/button/button';
import LoadIcon from 'components/bolt/sidePanel/loadIcon';
import IconList from 'components/bolt/icons/list';
import IconMap from 'components/bolt/icons/map';
import NotificationBanner from 'components/bolt/sidePanel/notificationBanner';
import QuotesCarousel from 'components/bolt/quotesCarousel/quotesCarousel';

import s from 'components/bolt/showtimes/showtimes2.sss';


let NotificationBannerWithIntersectionObserver = withIntersectionObserver(NotificationBanner);
let QuotesCarouselWithIntersectionObserver = withIntersectionObserver(QuotesCarousel);

export default class Showtimes2 extends BaseComp.default {

	renderModeSelector(inListOrMapView) {
		const loading = accessNested(this.props, 'store.showtimes.loading');
		const fontStyles = accessNested(this.props, 'store.appData.styling.fontVariables');
		const { mode, mapSelectedTheater, mapTheaterExpanded } = this.state;
		let copy = accessNested(this.props, 'store.appData.copy', {});

		let icons = <LoadIcon />;

		if (!loading) {
			let setListMode = this.setListMode;
			// Need to use the menu back arrow to go back
			if (mapTheaterExpanded && mapSelectedTheater) {
				setListMode = undefined;
			}
			const customMapIcon = accessNested(this.props, 'store.appData.styling.imageVariables.showtimesMapViewIcon', '');
			icons = [
				<Button class={joinClasses({ s, listIcon: true, active: (mode === 'list' && loading === false) })} trigger={setListMode} ariaLabel={copy.accessibilityCopy.$LIST_VIEW_ARIA}>
					<IconList />
				</Button>,
				<Button class={joinClasses({ s, mapIcon: true, active: mode === 'map', custom: customMapIcon })} trigger={this.setMapModeButton} ariaLabel={copy.accessibilityCopy.$MAP_VIEW_ARIA}>
					{customMapIcon ? <div class={s.customMapIcon} style={`-webkit-mask: url(${customMapIcon}) no-repeat center;`} /> : <IconMap />}
				</Button>
			];
		}

		let ctaText = copy.baseCopy.$SELECT_A_SHOWTIME;
		if (loading) {
			ctaText = copy.baseCopy.$LOADING_CINEMAS;
		} else if (!(accessNested(this.props, 'store.showtimes.data') || []).length) {
			ctaText = '';
		} else if (mode === 'map') {
			ctaText = copy.baseCopy.$SELECT_A_CINEMA;
		}

		const quotesCarousel = (getShowtimesData() || {}).quotesCarousel;
		const quotesCarouselAllowedRegions = (quotesCarousel?.regions || '').split(',').map(a => a.trim()).filter(a => a);
		const clientRegion = this.props.store?.client?.geo?.countryCode;
		const hasQuotesCarousel = quotesCarousel && (quotesCarouselAllowedRegions.length < 1 || quotesCarouselAllowedRegions.includes(clientRegion));
		const displayNotificationBanner = accessNested(this.props, 'store.appData.pages.boltShowtimes.data.groupBookings.displayNotificationBanner', false);
		const notificationBannerVisible = this.state.selectedTab == 'Group Bookings' && displayNotificationBanner;

		return (
			<div class={s.modeWrapper}>
				{notificationBannerVisible && (
					<NotificationBannerWithIntersectionObserver
						isShowtimes
						region={this.props.store?.client?.geo?.countryCode}
						movies={this.props.store?.showtimes?.movies}
						intersectionObserver={this.state.observerTheaters}
						// which mode the user is viewing
						listOrMapMode={mode}
						// which container (list or map) this instance of Notif Banner is rendered in
						inListOrMapView={inListOrMapView}
						key="showtimesNotificationBanner"
					/>
				)}

				{hasQuotesCarousel && (
					<QuotesCarouselWithIntersectionObserver
						data={quotesCarousel}
						client={this.props.store?.client}
						isShowtimes
					/>
				)}
				<div class={s.mode}>
					<div class={joinClasses(s.cta, fontStyles.showtimesLoading)}>
						{ctaText}
					</div>
					<div class={s.icons}>
						{icons}
					</div>
				</div>
			</div>
		);
	}
}

function withIntersectionObserver(Comp) {
	class IntersectionObserverComp extends Component {
		constructor(props) {
			super(props);
			this.$el = {};
		}

		componentDidMount() {
			if (this.props.intersectionObserver) {
				this.intersectionObserver = this.props.intersectionObserver;
				this.observe();
			}
		}

		observe() {
			if (this.intersectionObserver && this.$el && this.$el.base instanceof window.Element) {
				this.prevEl = this.$el.base;
				this.intersectionObserver.observe(this.$el.base, this.props);
			}
		}

		unobserve() {
			if (this.intersectionObserver && this.prevEl) {
				this.intersectionObserver.unobserve(this.prevEl);
			}
		}

		componentDidUpdate(prevProps) {
			if (this.props.intersectionObserver !== this.intersectionObserver) {
				this.unobserve();
				this.intersectionObserver = this.props.intersectionObserver;
				this.observe();
			} else if (this.$el.base !== this.prevEl) {
				this.unobserve();
				this.observe();
			}
		}

		componentWillUnmount() {
			this.unobserve();
			this.intersectionObserver = null;
			// gb hack
			// Store.get().set({ groupBookingsShowtimes: false });
		}

		render() {
			return (
				<Comp ref={e => this.$el = e} {...this.props} intersectionObserver={null} />
			);
		}
	}
	return IntersectionObserverComp;
}